import { render } from "./count-up.vue?vue&type=template&id=3a40915a"
import script from "./count-up.vue?vue&type=script&setup=true&lang=ts"
export * from "./count-up.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3a40915a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a40915a', script)) {
    api.reload('3a40915a', script)
  }
  
  module.hot.accept("./count-up.vue?vue&type=template&id=3a40915a", () => {
    api.rerender('3a40915a', render)
  })

}

script.__file = "resources/scripts/components/ui/count-up.vue"

export default script